import AddEvaluationManagerFormLanding from '../../../views/appraisal/evaluation/addEvaluationSelf/AddEvaluationManagerFormLanding';
import AddEvaluationSelfFormLanding from '../../../views/appraisal/evaluation/addEvaluationSelf/AddEvaluationSelfFormLanding';
import ToolTip from '../../ToolTip/ToolTip';

const handleToolTip = (value) => {
  return <ToolTip content={value} expand={value} />;
};

const evaluationStatusesJson = [
  { id: 0, name: 'Pending' },
  { id: 1, name: 'Self Appraisal Completed' },
  { id: 2, name: 'Manager Appraisal Completed' },
];

export const selfAppraisalTableHeader = (api, SelfAppraisalDispatchParams) => [
  {
    field: 'sl_no',
    headerName: 'Sl No',
  },
  {
    field: 'appraisal_cycle_name',
    headerName: 'Cycle Name',
    width: 250,
  },
  {
    field: 'selfAppraisalStartDate',
    headerName: 'Self Appraisal Start Date',
    width: 200,
  },
  {
    field: 'selfAppraisalEndDate',
    headerName: 'Self Appraisal End Date',
    width: 200,
  },

  {
    field: 'evaluation_status',
    headerName: 'Status',
    width: 250,
    valueGetter: (params) => {
      return evaluationStatusesJson.find((sts) => sts.id == params.row?.evaluation_status)?.name || 'Other';
    },
  },
  {
    field: 'isSelfAppraisalActive ',
    headerName: 'Appraisal Deadline Status',
    width: 200,
    valueGetter: (params) => {
      return params.row?.isSelfAppraisalActive ? 'Active' : 'Date Expired';
    },
  },
  {
    field: 'appraisal_cycle_assignment_published_date',
    headerName: 'Publish Status',
    width: 150,
    valueGetter: (params) => {
      return params.row?.appraisal_cycle_assignment_published_date ? 'Published' : 'Not Published';
    },
  },
  {
    field: 'action',
    headerName: 'Action',
    width: 250,
    renderCell: (params) => {
      const viewOnly = params.row?.evaluation_status != 0;
      const publishedIsNull = params.row?.appraisal_cycle_assignment_published_date == null; // true if null or undefined
      // Disable if not active when not in view mode, or if in view mode and not published
      const extraDisable = viewOnly?false:!params.row?.isSelfAppraisalActive
      return (
        <>
          {publishedIsNull ? (
            <AddEvaluationSelfFormLanding
              id={params.row?.appraisal_cycle_id}
              title={params.row?.appraisal_cycle_name}
              afterFormSubmissionApi={api}
              AfterFormdispatchParams={SelfAppraisalDispatchParams}
              extraDisable={extraDisable} //DISABLE THE BUTTON BASED ON publish date or activity
              viewOnly={viewOnly} //IF THE SELF APPRAISAL COMPLETED IT IS CONVERTED TO VIEW MODE
            />
          ) : (
            <AddEvaluationManagerFormLanding
              userID={params.row.userID}
              id={params.row.appraisal_cycle_id}
              title={params.row.appraisal_cycle_name}
              // afterFormSubmissionApi={api}
              // AfterFormdispatchParams={dispatchParams}
              buttonName={"View Evaluation Report"}
              extraDisable={false}
              isAdmin={false}
              viewOnly={true} //IF THE MANAGER APPRASIAL COMPLETED 2 IT IS CONVERTED TO VIEW MODE or THE NO MANGER APPEAISAL NEEDED THEN ALSO VIEW MODE
            />
          )}
        </>
      );
    },
  },
];
